import * as yup from 'yup';

import moment from 'moment';

export const schema = yup.object().shape({
  numCartao: yup.string().required('Num. do Cartão deve ser preenchido'),
  codigoCartao: yup.string().required('CVV deve ser preenchido'),
  titular: yup
    .string()
    .required('Titular deve ser preenchido')
    .test('fullName', 'Nome completo do titular', (value) => {
      const name = value.trim().split(' ');
      return name.length >= 2;
    }),
  validade: yup
    .string()
    .required('Validade deve ser preenchido')
    .test('data', 'Data Inválida', (value) => {
      if (!value) {
        return false;
      }
      const split_validate = value.split('/');
      const month = moment(new Date()).format('MM');
      const year = moment(new Date()).format('YYYY');
      const data = moment(
        `01/${split_validate[0]}/20${split_validate[1]}`,
        'DD/MM/YYYY'
      ).format('DD/MM/YYYY');
      if (data.includes('Invalid')) {
        return false;
      }
      if (parseInt(`20${split_validate[1]}`, 0) < parseInt(year, 0)) {
        return false;
      }
      if (
        `20${split_validate[1]}` === year &&
        parseInt(split_validate[0], 0) < parseInt(month, 0)
      ) {
        return false;
      }
      return true;
    }),
});
